
import React from "react";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { DataSource } from "@/components/data-tables/DataTables";
import { sampleForecastModels } from "./sampleData";
import { ForecastTabContent } from "./ForecastTabContent";

export function ForecastModels() {
  const handleViewData = (data: DataSource) => {
    console.log("View data tables", data);
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-3xl font-bold tracking-tight">Forecast Models</h2>
        <p className="text-muted-foreground">
          Create and manage multi-year financial projections for your projects
        </p>
      </div>
      
      <Tabs defaultValue="operational" className="space-y-4">
        <TabsList>
          <TabsTrigger value="operational">Operational Projects</TabsTrigger>
          <TabsTrigger value="pre-revenue">Pre-Revenue Projects</TabsTrigger>
        </TabsList>
        
        <TabsContent value="operational" className="space-y-4">
          <ForecastTabContent 
            models={sampleForecastModels}
            isPreRevenue={false}
            onViewData={handleViewData}
          />
        </TabsContent>
        
        <TabsContent value="pre-revenue" className="space-y-4">
          <ForecastTabContent 
            models={sampleForecastModels}
            isPreRevenue={true}
            onViewData={handleViewData}
          />
        </TabsContent>
      </Tabs>
      
      <div className="flex justify-end">
        <Button>Create New Forecast Model</Button>
      </div>
    </div>
  );
}
